import { Chevron } from '@tink/core/src/components/atoms/Icons/Chevron';
import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { FlexBox } from '../../../../../atoms/FlexBox/FlexBox';
import { StyledHeader, StyledText, UnderlineWrapper } from './ListItem.styles';

export type ListItemProps = {
  text: string;
  Icon?: JSX.Element;
  title?: string;
};

export const ListItem = ({ text, Icon, title }: ListItemProps) => {
  return (
    <FlexBox alignItems="center">
      {Icon}
      <Box ml="normal" fullWidth>
        <UnderlineWrapper>
          <StyledText as="span">
            {title ? <StyledHeader>{title}</StyledHeader> : null}
            {text}
          </StyledText>
          <Chevron direction="right" color="greyLight" fontSize="normedium" />
        </UnderlineWrapper>
      </Box>
    </FlexBox>
  );
};
